import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Field, Form } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from '../../context';
import {
    faFileAlt,
    faPaperclip,
    faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import FieldTitle from './FieldTitle';
import hasPermission from '../Shared/hasPermission';

// TODO: much more indepth refactor needed later; Break this up
const NewCommunicationForm = (props) => {
    const { cancel, cancelAction, practiceId } = props;

    const dispatch = useDispatch();
    const [files, setFiles] = useState([]);
    const [isHoldingShift, setIsHoldingShift] = useState(false);
    const [oneBack, setOneBack] = useState(-1);
    const [twoBack, setTwoBack] = useState(-1);
    const [atBoxVisible, setAtBoxVisible] = useState(false);
    const [atPosition, setAtPosition] = useState(-1);
    const [mentionFilterString, setMentionFilterString] = useState('');
    const [people, setPeople] = useState([]);
    const [currentlyTaggedUsers, setCurrentlyTaggedUsers] = useState([]);
    const [communicationPartners, setCommunicationPartners] = useState([]);

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canManageCommunications = hasPermission(
        'ManageCommunications',
        permissions
    );

    useEffect(() => {
        dispatch(
            actions.communication.getCommunicationPartners(practiceId)
        ).then((res) => setCommunicationPartners(res?.data.data || []));
    }, [dispatch, practiceId]);

    const resetForm = () => {
        setCurrentlyTaggedUsers([]);
        setPeople([]);
        setMentionFilterString('');
        setAtBoxVisible(false);
        setFiles([]);
    };

    const submitForm = async (vals, form) => {
        let payload = {
            ...vals,
        };
        try {
            var formData = new FormData();

            formData.append('communication.practiceId', practiceId);
            formData.append('communication.details', payload.details);
            formData.append(
                'communication.partnerId',
                payload.partnerId || communicationPartners[0].id
            );
            formData.append('communication.title', payload.title);
            currentlyTaggedUsers.forEach((user, index) => {
                formData.append(
                    `communication.MentionedAccounts[${index}].id`,
                    user.id
                );
                formData.append(
                    `communication.MentionedAccounts[${index}].name`,
                    user.name
                );
            });

            var fileElement = document.getElementById('communicationFiles');
            if (fileElement) {
                Array.from(fileElement.files).forEach((file) =>
                    formData.append('Attachments', file)
                );
            }

            dispatch(
                actions.communication.createNewCommunication(formData)
            ).then(
                (res) => closeForm(form, res.data),
                (err) => console.error(err)
            );
        } catch (e) {
            console.error(e);
        }
    };

    const closeForm = (form, newId) => {
        form.reset();
        cancelAction(newId);
    };

    const toggleAtBox = (position, val = null) => {
        if (val !== null) {
            if (val === true) {
                setAtPosition(position);
                setAtBoxVisible(val);
            } else {
                setAtBoxVisible(val);
            }
        } else {
            setAtBoxVisible(!atBoxVisible);
        }
    };

    const handleMentionedUser = (user, form) => {
        let text = document.getElementById('newCommunicationDetails').value;
        let beforeAt = text.substring(0, atPosition);
        let afterAt = text
            .slice(atPosition + 1)
            .replace(mentionFilterString, '');
        const newText = `${beforeAt}@${user.firstName} ${user.lastName}${afterAt}`;
        setCurrentlyTaggedUsers([
            ...currentlyTaggedUsers,
            { name: `@${user.firstName} ${user.lastName}`, id: user.id },
        ]);
        form.details = newText;
        setAtBoxVisible(false);
        return form;
    };

    //handles if we're holding shift and pressing 2
    const handleKeyDownInput = (event, values) => {
        if (event !== null) {
            if (event.keyCode === 16) setIsHoldingShift(true);
            if (isHoldingShift && event.keyCode === 50) {
                toggleAtBox(event.target.selectionStart, true);
                var users = canManageCommunications
                    ? (communicationPartners || []).filter(
                          (p) => p.partnerId === values?.partnerId
                      )[0]
                    : communicationPartners[0];
                setPeople(((users || {})?.accounts || []).slice(0, 4));
            }
        }
    };

    const resetFilterString = () => setMentionFilterString('');
    const fileInputChange = (e) => {
        setFiles([]);
        let fileList = [];
        Array.from(e.target.files).forEach((file) => fileList.push(file.name));
        setFiles(fileList);
    };

    const clearFiles = () => {
        const inputElement = document.getElementById('communicationFiles');
        inputElement.value = '';
        setFiles([]);
    };

    //@-mention handling
    const handleKeyUpInput = (event, values) => {
        //keep track of most recent keys
        setTwoBack(oneBack);
        setOneBack(event.keyCode);
        if (event !== null) {
            switch (event.keyCode) {
                case 16: //released shift
                    setIsHoldingShift(false);
                    break;
                case 27: //esc
                    toggleAtBox(-1, false);
                    resetFilterString();
                    break;
                case 8: //backspace
                default:
                    // did we just do '@'?
                    if (
                        (event.keyCode === 8 &&
                            oneBack === 16 &&
                            twoBack === 50) ||
                        event.target.selectionStart <= atPosition
                    ) {
                        toggleAtBox(-1, false);
                        resetFilterString();
                    }
                    if (event.target.selectionStart < atPosition) {
                        toggleAtBox(-1, false);
                        resetFilterString();
                        break;
                    }
                    if (atBoxVisible) {
                        const cursorPosition = event.target.selectionStart;
                        let text = document.getElementById(
                            'newCommunicationDetails'
                        ).value;
                        const filterText = text.substring(
                            atPosition + 1,
                            cursorPosition
                        );
                        setMentionFilterString(filterText);
                        const users = canManageCommunications
                            ? communicationPartners.filter(
                                  (p) => p.partnerId === values?.partnerId
                              )[0]
                            : communicationPartners[0];
                        const updatedUsers = ((users || {})?.accounts || [])
                            .filter(
                                (user) =>
                                    filterText.length === 0 ||
                                    `${user.firstName} ${user.lastName}`
                                        .toLowerCase()
                                        .includes(filterText.toLowerCase())
                            )
                            .slice(0, 4);
                        setPeople(updatedUsers);
                    }
            }
        }
    };

    const getMentionBoxStyle = (count = 1) => {
        return {
            transform:
                count > 0
                    ? `translate(0px, -${55 + (count - 1) * 25}px)`
                    : `translate(0px, -55px)`,
            zIndex: '1000',
        };
    };

    return (
        <Form
            initialValues={{}}
            onSubmit={submitForm}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col className="px-5 mb-4 d-flex justify-content-between text-light">
                            <h3>New Communication</h3>
                            <h3>
                                <FontAwesomeIcon
                                    className="hoverable"
                                    onClick={cancel}
                                    icon={faTimes}
                                />
                            </h3>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center text-light">
                        <Col md="9" xs="12" className="mb-1">
                            <FieldTitle title="Title" required />
                            <Field
                                name="title"
                                placeholder="Communication title"
                                className="rounded w-100 p-2 border"
                                required
                                component="input"
                                type="text"
                            />
                        </Col>
                        {canManageCommunications && (
                            <Col md="9" xs="12" className="mb-1">
                                <FieldTitle title="Partner" required />
                                <Field
                                    name="partnerId"
                                    className="rounded w-100 p-2"
                                    required
                                    placeholder="Partner"
                                    component="select"
                                    label="Select Partner"
                                    defaultValue={''}>
                                    <option value="" disabled>
                                        Select partner
                                    </option>
                                    <option />
                                    {(communicationPartners || []).map(
                                        (p) => (
                                            <option key={p.partnerId} value={p.partnerId}>
                                                {p.partner}
                                            </option>
                                        )
                                    )}
                                </Field>
                            </Col>
                        )}
                        <Col md="9" xs="12" className="mb-1">
                            {atBoxVisible && (
                                <div
                                    className="position-absolute w-50 p-1 bg-light sc-rounded text-dark sc-shadow border border-secondary"
                                    style={getMentionBoxStyle(
                                        (people || []).length
                                    )}>
                                    <div className="text-12">
                                        Mention a user
                                    </div>
                                    <div className="px-1">
                                        {(people || []).length === 0 && (
                                            <span className="px-2">
                                                No users
                                            </span>
                                        )}
                                        {(people || [])
                                            .slice(0, 4)
                                            .map((u, x) => (
                                                <div
                                                    key={u.id}
                                                    className="hoverable hide-overflow darken-user-on-hover px-2 rounded"
                                                    onClick={() => {
                                                        form =
                                                            handleMentionedUser(
                                                                u,
                                                                values
                                                            );
                                                        document
                                                            .getElementById(
                                                                'newCommunicationDetails'
                                                            )
                                                            .focus();
                                                    }}>
                                                    {u.firstName} {u.lastName} |{' '}
                                                    {u.email}
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            )}
                            <FieldTitle title="Details" required />
                            <Field
                                className="rounded w-100 p-2"
                                component="textarea"
                                id="newCommunicationDetails"
                                name="details"
                                onKeyDown={(e) => handleKeyDownInput(e, values)}
                                onKeyUp={(e) => handleKeyUpInput(e, values)}
                                placeholder="Communication Details"
                                required
                                rows="8"
                            />
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center">
                        <Col
                            md="9"
                            xs="12"
                            className="d-flex justify-content-between">
                            <div>
                                <label
                                    id="communicationUploadFile"
                                    className="file-upload p-2"
                                    title="Upload a file or screenshot">
                                    <input
                                        type="file"
                                        id="communicationFiles"
                                        onChange={(e) => fileInputChange(e)}
                                        multiple
                                    />
                                    <FontAwesomeIcon
                                        icon={faPaperclip}
                                        size="lg"
                                    />
                                </label>
                                <UncontrolledTooltip target="communicationUploadFile">
                                    Upload a file or screenshot (Max 28 MB)
                                </UncontrolledTooltip>
                            </div>
                            <span>
                                <Button
                                    className="mx-2"
                                    color="danger"
                                    onClick={() => {
                                        form.reset();
                                        resetForm();
                                    }}
                                    disabled={pristine}>
                                    Clear
                                </Button>
                                <Button
                                    className="mx-2"
                                    color="success"
                                    disabled={
                                        pristine ||
                                        submitting ||
                                        (!values?.title &&
                                            !values?.details &&
                                            !files?.length > 0)
                                    }
                                    type="submit">
                                    Create
                                </Button>
                            </span>
                        </Col>
                        <Col xs="12">
                            {files?.map((file, index) => (
                                <div
                                    className="bg bg-info text-light d-inline-block ml-4 p-2 rounded"
                                    title={file}
                                    key={index}>
                                    <FontAwesomeIcon
                                        size="lg"
                                        icon={faFileAlt}
                                    />
                                    &emsp;{' '}
                                    <span className="w-66 hide-overflow">
                                        {file.substring(0, 20)}
                                        {file.length > 20 ? '...' : ''}
                                    </span>
                                    &emsp;{' '}
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        onClick={() => clearFiles()}
                                        size="lg"
                                        title="Remove this File"
                                        className="hoverable"
                                    />
                                </div>
                            ))}
                        </Col>
                    </Row>
                </form>
            )}></Form>
    );
};

export default NewCommunicationForm;
